import axios from 'axios';
import { processResponse, processError } from '../utils';
export default class HeroSmsAppLink {
    static send(constAccessParams, mobile) {
        return axios
            .post(constAccessParams.API_ENDPOINT + 'frontend/sms-app-link/', { mobile })
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
}
//# sourceMappingURL=index.js.map